import { ArrowLeft, Bell, Edit } from 'assets'
import React, { useEffect, useState } from 'react'
import { Container } from 'reactstrap'
import './detail.scss'
import InfoLagu from './InfoLagu'
import { API_GET_MAMBOO, API_PUT_MAMBOO } from 'services'
import DetailLagu from './DetailLagu'
import HargaLagu from './HargaLagu'
import { FiCheck, FiX } from 'react-icons/fi'
import CustomButton from 'components/CustomButton'
import { Alert, AlertNotif } from 'components/Alert'
import { getCookie } from 'services/cookies'

/**
 * Detail lagu, sekaligus formulir Edit.
 *
 * @param {boolean} [props.canEdit]  timpa aturan bawaan "role 3 tidak boleh
 *   menyunting". Dipakai halaman Register Request: lagu yang DITOLAK harus
 *   bisa direvisi pencipta yang mengajukannya.
 * @param {boolean} [props.hideHarga]  sembunyikan Opsi Pemakaian Lagu &
 *   Kustomisasi Harga. Harga adalah kewenangan publisher; nilainya tetap ikut
 *   terkirim apa adanya saat disimpan.
 * @param {string} [props.declineNote]  alasan penolakan, ditampilkan di atas
 *   formulir supaya pencipta tahu apa yang perlu diperbaiki.
 * @param {"detail"|"edit"} [props.initialPage]
 * @param {{onApprove: Function, onDecline: Function, busy?: boolean}|null}
 *   [props.reviewActions]  tombol keputusan publisher, supaya pengajuan bisa
 *   dibaca lebih dulu sebelum disetujui atau ditolak.
 * @param {boolean} [props.lockNama]  tampilkan Nama Pencipta sebagai teks, bukan
 *   dropdown. Untuk pencipta, susunan namanya memang tetap — dan teks statis
 *   selalu menampilkan nama yang tersimpan, tanpa bergantung pada daftar opsi.
 */
const Detail = ({
  data,
  rowData,
  handleOnClick,
  canEdit,
  hideHarga = false,
  declineNote = "",
  initialPage = "detail",
  reviewActions = null,
  lockNama = false,
}) => {
  const [creator, setCreator] = useState([])
  const [genre, setGenre] = useState([])
  const [era, setEra] = useState([])
  const [projectType, setProjectType] = useState([])
  const [role, setRole] = useState([])
  const [pencipta, setPencipta] = useState([])
  const [page, setPage] = useState(initialPage)

  // Bawaan: semua peran kecuali pencipta (role 3) boleh menyunting. `canEdit`
  // menimpanya bila pemanggil punya aturan sendiri.
  // Cookie selalu berisi string, jadi dibandingkan sebagai string.
  const isEditAllowed =
    canEdit === undefined ? String(getCookie("publisher")) !== "3" : canEdit

  // Work ID hanya bisa disunting publisher/admin, dan hanya dalam mode edit —
  // pada pendaftaran, backend selalu membuatnya sendiri. `lockNama` menandai
  // formulir yang sedang dipakai songwriter.
  const canEditWorkId = page === "edit" && !lockNama

  const [isErrorPembagian, setIsErrorPembagian] = useState(false)
  const [penciptaHeader, setPenciptaHeader] = useState({
    song_id: data.lisence[0].song_id || "",
    created_at: data.lisence[0].created_at || "",
    creator_code: data.lisence[0].creator_code || "",
    creator_id: data.lisence[0].creator_id || "",
    creator_name: data.lisence[0].creator_name || "",
    lisence_detail_id: data.lisence[0].lisence_detail_id || "",
    namaPencipta: data.lisence[0].creator_name || "",
    sebagai: data.lisence[0].creator_code || "",
    mech: data.lisence[0].mech || 0,
    perform: data.lisence[0].perform || 0,
    sync: data.lisence[0].sync || 0,
    demd: data.lisence[0].demd || 0,
    isErrorNama: false,
  })

  const [dataPencipta, setDataPencipta] = useState(data.lisence.slice(1).map((data) => {
    return {
      ...data,
      namaPencipta: data.creator_name,
      sebagai: data.creator_code
    }
  }) || [])
  const [judulLain, setJudulLain] = useState(data.song_info.another_song_title || [])
  const [informasiLagu, setInformasiLagu] = useState({
    judul_lagu: data.song_info.song_title || "",
    iswc_number: data.song_info.iswc_number || "",
    judul_lain: [],
    link_youtube: data.song_info.youtube_link || "",
    // Work ID = kolom `id` lagu. Respons detail (song_info) belum membawanya,
    // jadi diambil dari baris list yang diklik (lihat toTableRows di
    // KatalogLagu — `rowData.id` di sana sudah berisi song_id).
    work_id: rowData?.work_id || ""
  })
  // Dari publisher.song_asset lewat respons detail. `song_asset_id` dibawa
  // supaya backend bisa mengenali baris yang sudah ada dan tidak membuat ulang.
  const [asetId, setAsetId] = useState((data.asset || []).map((row) => ({
    song_asset_id: row.song_asset_id,
    asset_id: row.asset_id,
    dsp_code: row.dsp_code || "",
  })))
  const [dspOptions, setDspOptions] = useState([])

  const [dataPenyanyi, setDataPenyanyi] = useState(data.singer.map((singer) => {
    return {
      ...singer,
      nama_penyanyi: singer.singer,
      isrc_number: singer.isrc_number
    }
  }) || [
      {
        nama_penyanyi: '',
        isrc_number: ''
      }
    ])



  const [dataDetailLagu, setDataDetailLagu] = useState(data.detail_lagu || {
    genre: "",
    era: ""
  })

  const onChangeSelect = (val) => {
    setDataDetailLagu((prev) => ({ ...prev, [val.name]: val }))
  }

  // const [usage, setUsage] = useState({
  //   is_exclusive: data.song_usage_option.is_exclusive,
  //   is_monthly: data.song_usage_option.is_monthly
  // })
  const [usage, setUsage] = useState(data.song_usage_option || {})

  const [price, setPrice] = useState([])

  function handleInitState() {
    // const initData = projectType.map((project) => {
    //   let tempData = {
    //     project_type: project.project_code,
    //     price: "",
    //     is_checked: false,
    //     sub_detail: project.sub_detail ? project.sub_detail.map((prosub) => {
    //       return {
    //         project_type_parent: prosub.project_type,
    //         is_checked: false,
    //         project_type: prosub.ads_code,
    //         price: ""
    //       }
    //     }) : null
    //   }
    //   data.price.forEach((value) => {
    //     if (value.project_type == project.project_code) {
    //       tempData = {
    //         project_type: project.project_code,
    //         price: String(value.price),
    //         is_checked: true,
    //         sub_detail: value.child.length > 0 ? project.sub_detail.map((sub) => {
    //           let tempSub = {
    //             project_type_parent: sub.project_type,
    //             is_checked: false,
    //             price: "",
    //             project_type: sub.ads_code
    //           }
    //           value.child.forEach((child) => {
    //             if (child.project_type == sub.ads_code) {
    //               tempSub = {
    //                 project_type_parent: child.project_type_parent,
    //                 is_checked: true,
    //                 project_type: sub.ads_code,
    //                 price: child.price
    //               }
    //             }
    //           })
    //           return tempSub
    //         }) : null
    //       }
    //     }
    //   })


    //   return tempData
    // })

    const hasParent = data.price.filter((val) => val.project_type_parent)
    const noParent = data.price.filter((val) => !val.project_type_parent)

    const initData = projectType.map((val) => {
      return {
        project_type: val.category_code,
        price: '',
        is_checked: false,
        sub_detail: val.project_type.map((project) => {
          let tempData = {
            project_type: project.project_code,
            price: "",
            is_checked: false,
            sub_detail: project.sub_detail ? project.sub_detail.map((data) => {
              let tempSub = {
                project_type_parent: data.project_type,
                is_checked: false,
                project_type: data.ads_code,
                price: ""
              }
              hasParent.forEach((val) => {
                if (val.project_type === data.ads_code) {
                  tempSub = {
                    ...tempSub,
                    price_id: val.price_id,
                    song_id: val.song_id,
                    created_at: val.created_at,
                    updated_at: null,
                    price: String(val.price),
                    // Baris berharga 0 adalah baris cadangan yang dibuat saat
                    // pendaftaran, bukan opsi yang benar-benar dipilih.
                    is_checked: Number(val.price) > 0
                  }
                }
              })
              return tempSub
            }) : null
          }
          noParent.forEach((val) => {
            if (val.project_type === project.project_code) {
              tempData = {
                ...tempData,
                price_id: val.price_id,
                song_id: val.song_id,
                created_at: val.created_at,
                updated_at: null,
                price: String(val.price),
                // Lihat catatan di atas: harga 0 berarti baris cadangan.
                is_checked: Number(val.price) > 0,
                child: !val.sub_detail && []
              }
            }
          })
          return tempData
        })
      }
    })

    const filteredData = [...initData].map((x) => ({
      ...x,
      sub_detail: x.sub_detail.filter((y) => {
        if (y.price && y.is_checked && y.project_type !== '07') return y
        if (y.project_type === '07') {

          return {
            ...y,
            sub_detail: y.sub_detail.filter((z) => z.price && z.is_checked)
          }
        }
      })
    }))

    // console.log('initData woi', { initData, projectType })
    setPrice(initData)
  }

  const onCheckUsage = (e) => {
    const { name, value, checked } = e.target
    const { is_exclusive, is_monthly } = data.song_usage_option
    // console.log(price)
    const checkUpdate = (name, checked) => {
      if (name === 'is_exclusive') {
        if (is_exclusive === usage[name] && is_monthly === usage.is_monthly) {
          return null
        }
        return Date.now()
      } else {

        if (is_monthly === usage[name] && is_exclusive === usage.is_exclusive) {
          return null
        }
        return Date.now()
      }
    }
    setUsage((prev) => ({ ...prev, [name]: checked, updated_at: checkUpdate(name, checked) }))
  }

  const onCheckHarga = (e, index, child, deepIndex) => {
    const { name, checked } = e.target
    const currentData = [...price]
    // console.log(checked)

    if (deepIndex || deepIndex >= 0) {
      currentData[index].sub_detail[child].sub_detail[deepIndex].is_checked = checked
      if (!checked) {
        currentData[index].sub_detail[child].sub_detail[deepIndex].price = 0
      }
      return setPrice(currentData)
    }

    if (child || child >= 0) {
      currentData[index].sub_detail[child].is_checked = checked
      if (!checked) {
        currentData[index].sub_detail[child].price = 0
      }
      return setPrice(currentData)
    }


    currentData[index].is_checked = checked
    if (!checked) {
      currentData[index].price = 0

    }
    setPrice(currentData)
  }


  const onChangePrice = (e, index, child, deepIndex) => {
    const { name, value } = e.target
    const regex = /[0-9]|\./
    if (!regex.test(value[value.length - 1]) && value) return
    const currentData = [...price]

    if (deepIndex || deepIndex >= 0) {
      currentData[index].sub_detail[child].sub_detail[deepIndex].price = value.replaceAll('.', '')
      currentData[index].sub_detail[child].sub_detail[deepIndex].is_checked = value ? true : false
      return setPrice(currentData)
    }

    if (child || child >= 0) {
      currentData[index].sub_detail[child].price = value.replaceAll('.', '')
      currentData[index].sub_detail[child].is_checked = value ? true : false
      return setPrice(currentData)
    }

    currentData[index].price = value.replaceAll('.', '')
    setPrice(currentData)
  }



  const refFormatter = (array, name) => {
    if (name === 'pencipta') {
      const filterData = data.lisence.filter((val) => val.creator_id === val.creator_name).map((value) => ({ label: value.creator_name, value: value.creator_name, id: value.creator_id }))
      const formatedArray = array.map((val) => ({ label: val.name, value: val.name, id: val.creator_id }))
      return [...filterData, ...formatedArray]
    }
    return array.map((val) => ({ label: val[name], value: val[`${name}_code`], name }))
  }

  const getCreator = async () => {
    await API_GET_MAMBOO.dynamic.getCreator()
      .then((response) => setCreator(refFormatter(response, 'creator')))
      .catch((err) => console.log(err))
  }

  const getEra = async () => {
    await API_GET_MAMBOO.dynamic.getEra()
      .then((response) => setEra(refFormatter(response, 'era')))
      .catch((err) => console.log(err))
  }

  const getGenre = async () => {
    await API_GET_MAMBOO.dynamic.getGenre()
      .then((response) => setGenre(refFormatter(response, 'genre')))
      .catch((err) => console.log(err))
  }

  const getRole = async () => {
    await API_GET_MAMBOO.dynamic.getRole()
      .then((response) => setRole(refFormatter(response, 'role')))
      .catch((err) => console.log(err))
  }

  const getProjectType = async () => {
    await API_GET_MAMBOO.dynamic.getProjectType()
      .then((response) => {
        response.forEach((data) => {
          data.project_type.forEach((val) => {
            if (val.sub_detail.length === 0) {
              val.sub_detail = null
            }
          })
        })
        setProjectType(response)
      })
      .catch((err) => console.log(err))
  }


  const getDsp = async () => {
    await API_GET_MAMBOO.dynamic.getDsp()
      .then((response) => setDspOptions(response.map((x) => ({ label: x.dsp, value: x.dsp_code }))))
      .catch((err) => console.log(err))
  }

  const getPencipta = async (keyword = '') => {
    await API_GET_MAMBOO.dynamic.getByRole('3', keyword, false ,false)
      .then((response) => setPencipta(refFormatter(response, 'pencipta')))
      .catch((err) => console.log(err))
  }



  const updateSong = async (data) => {
    await API_PUT_MAMBOO.update.updateSong(data)
      .then((res) => handleOnClick(''))
      .catch((err) => console.log(err))

  }


  const handleClickSimpan = async () => {
    setIsErrorPembagian([])
    const dataToSave = [penciptaHeader, ...dataPencipta]
    const todayTime = new Date(Date.now() - new Date(Date.now()).getTimezoneOffset() * 60000).toISOString()
    // const isError = errorChecker(dataToSave)
    // console.log('JALAN WOEOEOR')
    // console.log(dataToSave, 'to save save')
    const dataPrice = JSON.parse(JSON.stringify(price))
    let mech = 0
    let sync = 0
    let demd = 0
    let perform = 0

    dataToSave.forEach((data) => {
      mech += Number(data.mech)
      sync += Number(data.sync)
      demd += Number(data.demd)
      perform += Number(data.perform)
    })
    let isPembagianError = false
    if (perform !== 100 && perform > 0) {
      isPembagianError = true
      setIsErrorPembagian((prev) => [...prev, { name: 'Perform', isError: true }])
    }
    if (demd !== 100 && demd > 0) {
      isPembagianError = true
      setIsErrorPembagian((prev) => [...prev, { name: 'Demd', isError: true }])
    }
    if (sync !== 100 && sync > 0) {
      isPembagianError = true
      setIsErrorPembagian((prev) => [...prev, { name: 'Synchronize', isError: true }])
    }
    if (mech !== 100 && mech > 0) {
      isPembagianError = true
      setIsErrorPembagian((prev) => [...prev, { name: 'Mech', isError: true }])
    }

    let isNamaError = false

    dataToSave.some((data) => {
      if(!data.namaPencipta || !data.sebagai) {
        isNamaError = true
        return
      }
    })

    const errorName = []
    if(isNamaError) {
      errorName.push('Nama')
      errorName.push('Sebagai')
    }

    if(isPembagianError) {
      errorName.push('Pembagian Hak')
    }

    if (isPembagianError || isNamaError) {
      return AlertNotif({
        icon: 'warning',
        title: 'Data belum lengkap',
        html: `<p>Pastikan kolom ${errorName.map((x, index) => (`<b>${index === errorName.length - 1 && errorName.length > 1 ? ' dan ' : '' } ${x}${index !== errorName.length - 1 && errorName.length > 2 ? '' : ''}</b>`))} sudah terisi dengan benar.</p>`
      })
    }

    let priceData = []
    dataPrice.forEach((data) => priceData = [...priceData, ...data.sub_detail])

    const subDetailPrice = priceData.filter((val) => val.sub_detail)[0].sub_detail.filter((val) => val.is_checked && val.price)
    subDetailPrice.forEach((val) => {
      delete val.is_checked
      val.price = Number(val.price)
    })
    const payloadPrice = priceData.filter((val) => val.is_checked)
    payloadPrice.forEach((val) => {
      delete val.is_checked
      delete val.sub_detail

      val.price = Number(val.price)
    })

    const payloadHarga = {
      price: [...subDetailPrice, ...payloadPrice]
    }

    payloadHarga.price.forEach((val) => {
      if (val.price_id) {
        val.updated_at = todayTime
      }
    })


    const payload = {
      song_id: rowData.song_id,
      song_info: {
        // Hanya dikirim bila memang boleh disunting. Backend tetap menolaknya
        // untuk songwriter, tapi tidak perlu mengirim yang pasti dibuang.
        ...(canEditWorkId && { id: informasiLagu.work_id }),
        era: dataDetailLagu.era.value ? dataDetailLagu.era.value : dataDetailLagu.era,
        genre_code: dataDetailLagu.genre.value ? dataDetailLagu.genre.value : dataDetailLagu.genre,
        song_title: informasiLagu.judul_lagu,
        creator_id: dataToSave.map((data) => data.creator_id || data.namaPencipta),
        another_song_title: judulLain,
        iswc_number: informasiLagu.iswc_number,
        youtube_link: informasiLagu.link_youtube,
      },
      lisence: dataToSave.map((data) => ({
        lisence_detail_id: data.lisence_detail_id,
        song_id: data.song_id || rowData.song_id,
        creator_name: data.namaPencipta,
        creator_code: data.sebagai,
        creator_id: data.creator_id || data.namaPencipta,
        mech: Number(data.mech),
        perform: Number(data.perform),
        sync: Number(data.sync),
        demd: Number(data.demd),
        created_at: data.created_at,
        updated_at: data.lisence_detail_id && todayTime
      })),
      singer: dataPenyanyi.map((data) => ({
        singer_id: data.singer_id,
        song_id: data.song_id || rowData.song_id,
        singer: data.nama_penyanyi,
        isrc_number: data.isrc_number,
        created_at: data.created_at,
        updated_at: data.singer_id && todayTime
      })),
      song_usage_option: { ...usage, updated_at: todayTime },
      price: payloadHarga.price,
      // Dikirim utuh: backend menghapus baris yang sudah tidak ada di daftar
      // ini dan mempertahankan id baris yang masih ada (lihat updateSong).
      asset: asetId.map((row) => ({
        song_asset_id: row.song_asset_id,
        asset_id: row.asset_id,
        dsp_code: row.dsp_code || null,
      })),
    }

    // console.log({ payload, payloadHarga })


    Alert({
      icon: 'warning',
      title: 'Edit Lagu',
      text: `Pastikan data yang terisi sudah benar`,
      showCancelButton: true,
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Batal',
      confirmButtonColor: 'var(--danger)',
      successText: `Lagu '${informasiLagu.judul_lagu}' berhasil di Edit`,
      failText: `Lagu '${informasiLagu.judul_lagu} gagal di Edit`,
      cancelText: `Lagu '${informasiLagu.judul_lagu}' batal di Edit`,
      confirmed: () => updateSong(payload)
    })
  }

  useEffect(() => {
    if (projectType.length > 0) {
      handleInitState()
    }
  }, [projectType])


  useEffect(() => {
    getRole()
    getProjectType()
    getGenre()
    getEra()
    getCreator()
    getPencipta()
    getDsp()
  }, [])

  return (
    <Container fluid className="katalog-lagu-container">
      <div className="header-detail">
        <div className="katalog-header">
          <h1>{page === "detail" ? "Detail Lagu" : "Edit Lagu"}</h1>
        </div>
        <div className="icon-wrapper">
          <Bell />
        </div>
      </div>
      <div className="header-detail">
        <div className="container-kembali" onClick={() => handleOnClick("")}>
          <ArrowLeft style={{ stroke: 'var(--text-strong)' }} />
          <span className="text-kembali">Kembali</span>
        </div>
        {page !== "edit" && isEditAllowed && (
          <div className="container-button">
            <button onClick={() => setPage("edit")}>
              <Edit /> Edit Lagu
            </button>
          </div>
        )}
        {/* Wadah terpisah dari .container-button: selektor
            `.container-button button` di detail.scss memaksa gaya outline ke
            setiap tombol di dalamnya, dan kelas itu juga dipakai halaman
            transaksi — jadi tidak bisa dipersempit dari sini. */}
        {page !== "edit" && reviewActions && (
          <div className="lagu-review-actions">
            {/* Di halaman detail ruangnya cukup, jadi tetap berlabel — yang
                diselaraskan dengan daftar adalah warnanya: hijau menyetujui,
                merah menolak. */}
            <CustomButton
              label="Setujui"
              LabelIcon={FiCheck}
              iconPosition="left"
              className="button-approve"
              disabled={reviewActions.busy}
              onClick={reviewActions.onApprove}
            />
            <CustomButton
              label="Tolak"
              LabelIcon={FiX}
              iconPosition="left"
              className="button-decline"
              disabled={reviewActions.busy}
              onClick={reviewActions.onDecline}
            />
          </div>
        )}
      </div>
      {declineNote && (
        <div className="lagu-decline-note" role="status">
          <strong>Catatan penolakan publisher</strong>
          <p>{declineNote}</p>
        </div>
      )}
      <InfoLagu
        page={page}
        penciptaHeader={penciptaHeader}
        pencipta={pencipta}
        dataPencipta={dataPencipta}
        dataPenyanyi={dataPenyanyi}
        judulLain={judulLain}
        informasiLagu={informasiLagu}
        setPage={setPage}
        setPenciptaHeader={setPenciptaHeader}
        isErrorPembagian={isErrorPembagian}
        setDataPencipta={setDataPencipta}
        setDataPenyanyi={setDataPenyanyi}
        setJudulLain={setJudulLain}
        setInformasiLagu={setInformasiLagu}
        creator={creator}
        asetId={asetId}
        setAsetId={setAsetId}
        dspOptions={dspOptions}
        isNamaLocked={lockNama}
        isSongwriter={lockNama}
        canEditWorkId={canEditWorkId}
      />
      <DetailLagu
        page={page}
        onChangeSelect={onChangeSelect}
        genre={genre}
        era={era}
        dataDetailLagu={dataDetailLagu}
      />
      {!hideHarga && <HargaLagu
        page={page}
        onChangePrice={onChangePrice}
        onCheckHarga={onCheckHarga}
        onCheckUsage={onCheckUsage}
        usage={usage}
        price={price}
        projectType={projectType}
      />}
      {page === "edit" && (
        <div className="frame-button-simpan">
          <CustomButton
            label={"Simpan"}
            color="primary-btn"
            className="btn-simpan"
            onClick={handleClickSimpan}
          />
        </div>
      )}
    </Container>
  );
}

export default Detail